import moment from "moment";

export const getLatestDate = (...dateAry) => {
  const validDateInArray = dateAry.map(date => moment(date)).filter(date => date.isValid());
  return moment.max(validDateInArray);
};

export const isBeforeToday = date => {
  const checkDate = moment(date);
  return checkDate.isBefore(moment().startOf("day"));
};

export const calculateAge = birthdayStr => {
  const birthday = new Date(birthdayStr);
  const today = new Date();

  let age = today.getFullYear() - birthday.getFullYear();

  const hasHadBirthdayThisYear =
    today.getMonth() > birthday.getMonth() ||
    (today.getMonth() === birthday.getMonth() && today.getDate() >= birthday.getDate());

  if (!hasHadBirthdayThisYear) {
    age--;
  }

  return age;
};



// WEBPACK FOOTER //
// ./utils/date.js